<template>
    <div class="text-right mb-2 d-lg-none global__filter__close">
        <button class="btn btn-primary" @click="close">
            <i class="fas fa-times"></i>
        </button>
    </div>
</template>

<script>
    export default {
        methods: {
            close() {
                $('body').removeClass('global__filter--show');
                $('.global__filter').removeClass('show');
                $('.modal-backdrop.show').remove();
            }
        }
    }
</script>

<style lang="scss">
    .global__filter.show {
        .global__filter__close {
            display: block;
        }
    }

    .global__filter__close {
        display: none;
    }

    .global__filter--show {
        overflow: hidden;
        position: fixed;
        width: 100%;
        height: 100%;
    }
</style>
